<template>
  <v-container>
    <v-card>
      <v-card-title>게시판</v-card-title>
    </v-card>
  </v-container>
</template>

<script setup>
</script>

<style scoped>

</style>
